import { useEffect, useRef } from 'react'
import { ChatMessage } from 'types/chat-message'

export const useScrollBottom = (messageStack: ChatMessage[]) => {
  const bottomRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messageStack])
  return bottomRef
}
